import { injectable, interfaces } from 'inversify';
import { makeObservable, observable } from 'mobx';

export interface IProjectOverviewStore {
  waitingForAnnotationCount: number;
  draftsCount: number;
  toReviewCount: number;
  rejectedCount: number;
  acceptedCount: number;
  unclearCount: number;
  totalImageCount: number;
  publishMoreDatasets: boolean;
  unclearImageDate?: string;
  unclearImageId?: string;
  unclearImagesFilterId?: string;
}

export namespace IProjectOverviewStore {
  export const $: interfaces.ServiceIdentifier<IProjectOverviewStore> = Symbol('PROJECT_OVERVIEW_STORE');
}

@injectable()
export class ProjectOverviewStore implements IProjectOverviewStore {
  acceptedCount: number = 0;

  draftsCount: number = 0;

  rejectedCount: number = 0;

  toReviewCount: number = 0;

  totalImageCount: number = 0;

  unclearCount: number = 0;

  waitingForAnnotationCount: number = 0;

  publishMoreDatasets: boolean = false;

  unclearImageDate?: string = undefined;

  unclearImageId?: string = undefined;

  unclearImagesFilterId?: string = undefined;

  constructor() {
    makeObservable(this, {
      acceptedCount: observable,
      draftsCount: observable,
      rejectedCount: observable,
      toReviewCount: observable,
      totalImageCount: observable,
      unclearCount: observable,
      waitingForAnnotationCount: observable,
      publishMoreDatasets: observable,
      unclearImageDate: observable,
      unclearImageId: observable,
      unclearImagesFilterId: observable,
    });
  }
}
